module.exports = __webpack_public_path__ + "img/_bookmark_active.10d040bb.svg";